import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CaseStudies from "@/components/sections/CaseStudies";
import TrustWall from "@/components/sections/TrustWall";
import CTA from "@/components/sections/CTA";

export default function Portfolio({ onOpenPalette }: { onOpenPalette: () => void }) {
  return (
    <>
      <Navbar onOpenPalette={onOpenPalette} />
      <main className="pt-28 pb-12 page-fade" data-testid="portfolio-page">
        <CaseStudies />
        <TrustWall />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
